import { LxConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";

export const lxConfig: LxConfig = {
  navigation: {
    tabIcon: "lob_activities",
    tabTitleToken: "wizard.lx.tab.title.label"
  },
  lastSearch: {
    lastSearchKey: "lastSearchCookie",
    lobKey: "wizard-lx-pwa"
  },
  location: {
    destination: {
      inputName: "destination",
      icon: "place",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      labelToken: "wizard.package.flight.destination.label",
      pwaDialogQueryParam: "destination-lx",
      essAdapterConfig: {
        lob: "ACTIVITIES",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      },
      queryParams: {
        regionId: "rid"
      }
    }
  },
  date: {
    ISOSubmissionSupport: true,
    format: "yyyy-MM-dd",
    submissionFormat: "yyyy-MM-dd",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    midnightBookingOffset: 4,
    maxDaysRange: 14,
    invalidStartDateMessageToken: "wizard.datePicker.warning.activity.invalidFromDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.activity.invalidToDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    start: {
      labelToken: "wizard.activity.startDate.label"
    },
    end: {
      labelToken: "wizard.activity.endDate.label"
    },
    queryParam: {
      start: "startDate",
      end: "endDate"
    },
    dialogId: "from-to"
  },
  form: {
    action: "/things-to-do/search",
    submitButton: {
      locToken: "wizard.submit.label"
    }
  },
  heading: {
    fixedTitle: false,
    mobileLocToken: "wizard.mobile.label.lx"
  },
  elementId: "wizard-lx-pwa"
};
